<template>
  <form id="summary-form" @submit.prevent v-if="formData">

    <div v-if="!isStartup">
      <div class="field">
        <label class="label">
          Startup Name
        </label>
        <div class="sep-8"></div>
        <div class="control">
          <input v-model="formData['startup_name']" maxlength="40" type="text"
                 placeholder="What is your startup name?" class="input"
                 vrules="required">
        </div>
        <div class="help is-danger vrule" rule="required">
          This field is required.
        </div>
      </div>
      <div class="sep-16"></div>
      <file-btn v-model="formData['image_id']"></file-btn>
      <div class="sep-16"></div>
      <div class="field">
        <label class="label">
          Website
          <div class="sep-8"></div>
          <b-tooltip :label="getSummaryTooltip('Q3')"
                     v-if="getSummaryTooltip('Q3')"
                     type="is-light"
                     position="is-right" size="is-large" multilined>
            <div class="tooltip-icon">!</div>
          </b-tooltip>
        </label>

        <div class="control">
          <input v-model="formData['website']" type="text"
                 placeholder="Website"
                 class="input" >
        </div>
      </div>
      <div class="sep-16"></div>
      <div class="field">
        <label class="label">
          Contact Name
          <b-tooltip :label="getSummaryTooltip('Q4')"
                     v-if="getSummaryTooltip('Q4')"
                     type="is-light"
                     position="is-right" size="is-large" multilined>
            <div class="tooltip-icon">!</div>
          </b-tooltip>
        </label>
        <div class="sep-8"></div>
        <div class="control">
          <input v-model="formData['contact_name']" type="text"
                 placeholder="Contact Name" class="input"
                 vrules="required">
        </div>
        <div class="help is-danger vrule" rule="required">
          This field is required.
        </div>
      </div>
      <div class="sep-16"></div>
      <div class="field">
        <label class="label">
          Contact Email
          <b-tooltip :label="getSummaryTooltip('Q5')"
                     v-if="getSummaryTooltip('Q5')"
                     type="is-light"
                     position="is-right" size="is-large" multilined>
            <div class="tooltip-icon">!</div>
          </b-tooltip>
        </label>
        <div class="sep-8"></div>
        <div class="control">
          <input v-model="formData['contact_email']" type="email"
                 placeholder="name@example.com" class="input"
                 vrules="required|email">
        </div>
        <div class="help is-danger vrule" rule="email">
          Please enter a valid email.
        </div>
      </div>
    </div>

    <div class="sep-16"></div>
    <div class="field">
      <label class="label">
        Startup Pitch
        <b-tooltip :label="getSummaryTooltip('Q6')"
                   v-if="getSummaryTooltip('Q6')"
                   type="is-light"
                   position="is-right" size="is-large" multilined>
          <div class="tooltip-icon">!</div>
        </b-tooltip>
      </label>
      <div class="tip">
        Describe your platform in just a few words.
      </div>
      <div class="sep-8"></div>
      <div class="control">
        <FalconTextArea v-model="formData['startup_pitch']"
                        placeholder="Describe your platform in just a few words"
                        inline-style="min-height: 50px; " vtarget="textarea"
                        vrules="required" maxlength="60"></FalconTextArea>
      </div>
      <div class="help is-danger vrule" rule="required">
        This field is required.
      </div>

    </div>
    <div class="sep-16"></div>
    <div class="field">
      <label class="label">
        Startup Summary
        <b-tooltip :label="getSummaryTooltip('Q37')"
                   v-if="getSummaryTooltip('Q37')"
                   type="is-light"
                   position="is-right" size="is-large" multilined>
          <div class="tooltip-icon">!</div>
        </b-tooltip>
      </label>
      <div class="sep-8"></div>
      <div class="control">
        <FalconTextArea v-model="formData['startup_summary']"
                        placeholder="Summarize your startup idea, services, markets, potential …." cols="30" rows="10"
                        inline-style="min-height: 100px;" vtarget="textarea"
                        vrules="required" maxlength="200"></FalconTextArea>
      </div>
      <div class="help is-danger vrule" rule="required">
        This field is required.
      </div>
    </div>
    <div class="sep-16"></div>
    <div class="field">
      <label class="label">
        Startup Establishment Year
        <b-tooltip :label="getSummaryTooltip('Q30')"
                   v-if="getSummaryTooltip('Q39')"
                   type="is-light"
                   position="is-right" size="is-large" multilined>
          <div class="tooltip-icon">!</div>
        </b-tooltip>
      </label>
      <div class="sep-8"></div>
      <div class="control ">
        <div class="select">
          <select vrules="required" v-model="formData['established_year']" name="estYear" id="estYear">
            <option selected>Select Year</option>
            <option v-for="year in estYears" :value="year">
              {{ year }}
            </option>
          </select>
        </div>
      </div>
      <div class="help is-danger vrule" rule="required">
        This field is required.
      </div>
    </div>
    <div class="sep-16"></div>


    <radio-box :question="getQuestionByTag('Q9')"
               v-model="formData['Q9']"></radio-box>
    <div class="sep-16"></div>
    <radio-box :question="getQuestionByTag('Q12')"
               v-model="formData['Q12']"
               @onAnswer="onQ12Answer"
    ></radio-box>
    <div class="sep-16"></div>
    <div v-if="formData['Q12']">
      <radio-box :question="getQuestionByTag('Q13')"
                 v-if="getAnswerTitle('Q12').indexOf('Received previous funding') > -1"
                 v-model="formData['Q13']"></radio-box>

      <div v-if="getAnswerTag('Q12') !== 'A1' && getAnswerTag('Q12') !== 'A3'">
        <div class="sep-16"></div>
        <fund-use-input
            :title="getFundUseTitle"
            subtitle=""
            v-model="formData['requested_fund']"></fund-use-input>
        <div class="sep-32"></div>
        <div class="sep-16"></div>
      </div>


      <radio-box :question="getQuestionByTag('Q16')"
                 v-model="formData['Q16']"></radio-box>
      <div class="sep-16"></div>
    </div>

    <radio-box :question="getQuestionByTag('Q18')"
               @onAnswer="onQ18Answer"
               v-model="formData['Q18']"></radio-box>

    <div class="sep-16"></div>
    <div class="control field" v-if="getAnswerTitle('Q18') === 'Yes'">
      <label class="label">
        {{ getQuestionByTag('Q19').title }}
      </label>
      <div class="sep-8"></div>
      <div>
        <falcon-select vrules="required" vtarget="input[type=hidden]" :options="getQuestionByTag('Q19').answer_set"
                       label="title" v-model="formData['Q19']"></falcon-select>
      </div>
      <div class="help is-danger vrule" rule="required">
        This field is required.
      </div>
    </div>

    <div>
      <div class="field">
        <label class="label">
          Industry?
          <b-tooltip :label="getSummaryTooltip('Q42')"
                     v-if="getSummaryTooltip('Q42')"
                     type="is-light"
                     position="is-right" size="is-large" multilined>
            <div class="tooltip-icon">!</div>
          </b-tooltip>
        </label>
        <div class="sep-8"></div>
        <div class="control ">
          <div>
            <falcon-select :options="industries" vrules="required" vtarget="input[type=hidden]"
                           label="name" v-model="formData['industry_id']"></falcon-select>
          </div>

          <div class="vrule help is-danger" rule="required">
            This field is required.
          </div>
        </div>
        <div class="sep-16"></div>
      </div>
      <div class="field">
        <label class="label">
          In which country is the company based?
          <b-tooltip :label="getSummaryTooltip('Q40')"
                     v-if="getSummaryTooltip('Q40')"
                     type="is-light"
                     position="is-right" size="is-large" multilined>
            <div class="tooltip-icon">!</div>
          </b-tooltip>
        </label>
        <div class="sep-8"></div>
        <div class="control ">
          <div>
            <falcon-select :options="countries" vrules="required" vtarget="input[type=hidden]"
                           label="name" v-model="formData['country_id']"></falcon-select>
          </div>
          <div class="vrule help is-danger" rule="required">
            This field is required.
          </div>
        </div>
      </div>
      <div class="sep-8"></div>
    </div>

    <share-holder-input v-model="formData['share_holders']"></share-holder-input>

    <div class="sep-16"></div>

  </form>
</template>

<script>
import ShareHolderInput from "@/modules/calculator/components/ShareHolderInput";
import FundUseInput from "@/modules/calculator/components/FundUseInput";
import {FormValidation} from "@/shared/directives/formValidation";
import {LookupsAPI} from "@/apis/LookupsAPI";
import {range} from "@/shared/utils";
import RadioBox from "@/modules/calculator/components/RadioBox";
import {ProfileAPI} from "@/apis/ProfileAPI";
import Multiselect from "vue-multiselect";
import FalconSelect from '@/shared/forms/FalconSelect'
import FalconTextArea from '@/shared/forms/FalconTextArea'
import FileBtn from "@/shared/components/file-btn";
import {FormsMixin} from "@/modules/calculator/forms/FormsMixin";
// import store from "@/modules/calculator/store";
import store from "@/store";
import {mapGetters, mapState} from "vuex";

export default {
  name: "SummaryForm",
  store,
  // userStore,
  props: {
    questions: {
      type: Array,
      default: function () {
        return [];
      }
    },
    formData: Object
  },
  mixins: [FormsMixin],
  components: {ShareHolderInput, FundUseInput, RadioBox, Multiselect, FalconSelect, FileBtn, FalconTextArea},
  data() {
    return {
      loading: false,
      tooltips: {},
      formValidation: null,
      industries: [],
      countries: [],
      estYears: [], //establishment years
      year_range: (range(2010, new Date().getFullYear())).reverse(),
      ProfileAPI: ProfileAPI
    }
  },
  async mounted() {
    // await this.$store.dispatch('updateUserData')
    this.industries = await LookupsAPI.getIndustries();
    this.countries = await LookupsAPI.getCountries();
    this.formValidation = new FormValidation('#summary-form');
    this.generateEstYearRange();
  },
  methods: {
    getSummaryTooltip(tag) {
      return this.tooltips[tag];
    },
    generateEstYearRange() {
      if (this.estYears.length === 0) {
        let d = new Date();
        for (let i = d.getFullYear(); i >= 1900; i--) {
          this.estYears.push(i);
        }
      }
    },
    getData() {
      let data = this.formatAnswers();
      data['country_id'] = data['country_id']['id'];
      data['industry_id'] = data['industry_id']['id'];
      if (data['requested_fund'] && data['requested_fund']['fundUseList']) {
        data['requested_fund'] = {
          fund_use_list: JSON.parse(JSON.stringify(data['requested_fund']['fundUseList'])),
          requested_fund: parseInt(data['requested_fund']['requestedFund']),
        };
      } else {
        data['requested_fund'] = {
          requested_fund: 0,
          fund_use_list: [{
            'label': 'Product Development',
            'code': 'product_development',
            'value': 0,
          }, {
            'label': 'Sales and Marketing',
            'code': 'sales_marketing',
            'value': 0,
          }, {
            'label': 'Operations',
            'code': 'operations',
            'value': 0,
          }, {
            'label': 'Others',
            'code': 'others',
            'value': 0,
          }]
        }
      }
      delete data['requestedFund'];
      delete data['shareHolders'];
      return data;
    },
    onQ12Answer(answer, question) {
      if (answer.tag === 'A1') {
        delete this.formData['Q13'];
      }
    },
    onQ18Answer(answer, question) {
      if (answer.title === 'No') {
        delete this.formData['Q19'];
      }
    }
  },
  computed: {
    ...mapGetters(['isStartup']),
    getFundUseTitle() {
      return this.getAnswerTag('Q12') === 'A1' ||
      this.getAnswerTag('Q12') === 'A3' ? 'Total Available fund' : 'Total requested fund';
    }
  },
  async updated() {
    if (this.questions) {
      for (let question of this.questions) {
        this.tooltips[question.tag] = question.desc;
      }
    }


  }

}
</script>

<style scoped>

</style>
